import React from 'react';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PaymentForm from './paymentForm';
import { getPublicRental } from "../../../data/loca/rentals";
import { paymentCall, publishableKey } from "../../../data/loca/stripe";
import { IsNullOrEmpty } from "../../../services/CustomService";
import { calendarStrings } from '../../../services/calendarStrings';

import {
    useLoaderData
} from "react-router-dom";

import Moment from 'react-moment';
import 'moment/locale/fr';
export async function loader({ params }) {

    const rental = await getPublicRental(params.rentalId);

    let resp = await paymentCall(params.rentalId);
    var error = resp.error;
    
    var ClientSecret = resp.clientSecret;
    var Status = resp.status;

    let Key = await publishableKey();
    var key = Key.key;

    return { ClientSecret, Status, key, rental,  error };
}


export default function StripePayment() {
    const { ClientSecret, Status, key, rental, error } = useLoaderData();
    const stripePromise = loadStripe(key);
   
    const options = {
        clientSecret: ClientSecret
    };


    return (
        <div className="financialForm">
            <div id="thumbnail">
                {(!IsNullOrEmpty(rental.base64Picture)) ? (
                    <img className="depositImg" height="192" key={rental.publicId} alt={rental.name} src={rental.base64Picture || null} />
                ) : (
                    <div className="no-picture no-picture-large"></div>
                )}

                <div>
                    <h1>Location : {rental.name}</h1>

                  
                    <div id="thumbnail-form">
                        <label>Par :&nbsp;<b>{rental.clientFirstname} {rental.clientLastname}</b></label> ({rental.serviceName})
                        
                    </div>
                    <label>
                    Date :&nbsp;
                        <Moment locale="fr" calendar={calendarStrings}>
                            {new Date(rental.startDate)}
                        </Moment>
                        &nbsp;jusqu'&agrave;&nbsp;
                        <Moment locale="fr" calendar={calendarStrings}>
                            {new Date(rental.endDate)}
                        </Moment>

                    </label>

                    {Status === "Error" ? (
                        <h3>
                            {error}
                        </h3>
                    )
                        : (
                            <>
                        
                    <div className="contentForm"></div>
                    

                    {Status === "Created" ? (
                        <>
                            <h2>Je paie ma location par carte</h2>
                                        <p>Montant  : {rental.remainingToBePaidCents/100}€</p>
                            <Elements stripe={stripePromise} options={options}>
                            <PaymentForm />
                            </Elements>
                        </>
                    ) 
                        : (
                            <>
                                <h2>Paiement effectué avec succès !</h2>
                            </>
                        )}

                            </>
                        )}
                </div>
            </div>
        </div>
    )            
}